export var UserType;
(function (UserType) {
    UserType["ADMIN"] = "admin";
    UserType["OWNER"] = "owner";
    UserType["COACH"] = "coach";
    UserType["CLIENT"] = "client";
})(UserType || (UserType = {}));
//# sourceMappingURL=users.js.map